import { createSlice } from '@reduxjs/toolkit';
import _ from 'lodash';
import { generateReduxKeys } from '../../utils';

const initialState = generateReduxKeys({
    orders: [],
    openOrderId: null,
    orderItems: [],
});

const orderSlice = createSlice({
    name: 'order',
    initialState,
    reducers: {
        setOrders: (state, action) => {
            state.orders = action.payload;
        },
        setOrderItems: (state, action) => {
            state.orderItems = action.payload;
        },
        appendOrderItems: (state, action) => {
            const prevOrderItems = Array.isArray(state.orderItems) ? state.orderItems : [];

            const newOrders = Array.isArray(action.payload)
                ? action.payload
                : [action.payload];

            const merged = _.cloneDeep(prevOrderItems);

            newOrders.forEach((newOrder) => {
                const existing = _.find(merged, { product_netsuite_id: newOrder.product_netsuite_id });

                if (existing) {
                    existing.quantity = Number(newOrder.quantity) || 1;
                } else {
                    merged.push(newOrder);
                }
            });

            state.orderItems = merged;
        },
        removeOrderItemById: (state, action) => {
            const updatedOrders = state.orderItems.filter((order) => order.id !== action.payload);
            state.orderItems = updatedOrders;
        },
        updateOrderQuantityById: (state, action) => {
            const { id, quantity } = action.payload;

            const order = state.orderItems.find((o) => o.id === id);
            if (order) {
                order.quantity = Number(quantity) || 0;
            }
        },
        setOpenOrderId: (state, action) => {
            state.openOrderId = action.payload;
        },
    },
});

export const { setOrders, setOrderItems, appendOrderItems, removeOrderItemById, updateOrderQuantityById, setOpenOrderId } = orderSlice.actions;

export default orderSlice.reducer;
